import React from "react";
import { Dialog, DialogContent, DialogContentText, DialogTitle, DialogActions, Slide, Link } from "@mui/material";
import Button from '../components/Button';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function HintsDialog({ open, handleClose }) {

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>{"Hints & Examples"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">

          <u>Brand Hints</u>
          <ul>
            <li>You will only receive notifications for posts containing the exact brand name you enter. </li>
            <li>Make sure to double-check your spelling, as the best results will occur with correct spelling. Our algorithm does have some tolerance for spelling errors, but it is limited. </li>
          </ul>

          <u>Description Hints</u>
          <ul>
            <li>Specific descriptions will only trigger highly specific Reddit posts. </li>
            <li>Keep in mind that Reddit posters may describe the same watch in different ways. Consider making your description more general to ensure you don't miss any relevant posts. For example, use "Seiko, Alpinist" instead of "Seiko, SARB", as a poster may simply describe their SARB as an Alpinist on Reddit. </li>
            <li>You can leave the description field blank to receive notifications for every single watch of a certain brand (bear in mind that there are limits to how many notifications each account can receive per month). </li>
          </ul>

          <u>Examples</u>
          <ul>
            <li>Entering "Seiko, SSK" will result in notifications for many different colors of the SSK model. In contrast, "Seiko, SKK001" will only trigger notifications for that single colorway. </li>
            <li>Entering "Rolex, Datejust" will likely result in 20 notifications per day for many colors and generations of results, while "Rolex, Datejust 36mm Rose Gold Fluted Bezel Two Tone White Dial" will probably result in fewer, more specific notifications. </li>
            <li>Entering "Cartier, [blank]" will result in getting a notification for every single Cartier watch posted, regardless of description.</li>
          </ul>

          If you have any questions or need help creating watch subscriptions, don't hesitate to email us at <Link href="mailto:help@watchexchanger.com">help@watchexchanger.com</Link> for assistance!
          
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Ok</Button>
      </DialogActions>
    </Dialog>
  )
}